import { render, staticRenderFns } from "./DelegationModal.vue?vue&type=template&id=2b50ca03&scoped=true"
import script from "./DelegationModal.vue?vue&type=script&lang=js"
export * from "./DelegationModal.vue?vue&type=script&lang=js"
import style0 from "./DelegationModal.vue?vue&type=style&index=0&id=2b50ca03&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b50ca03",
  null
  
)

export default component.exports